import type {CompanyRegistrationFormData} from '@openapi/company-registration-form';
import {companyRegistrationApi} from '../client';

export const postValidate = async (
  companyRegistrationFormData: CompanyRegistrationFormData,
) => companyRegistrationApi.validate({companyRegistrationFormData});
